
const ringLabelMinRadius = 75
    , axisTicks = 6

import animations from './animations'

export {animations}

export const interactive = false

/*
 * Draws the rings
 */
const rings = (selection, dimensions, scaler) => {
  selection.each(function (d) {
    let group = selection.selectAll('g.rings')
                         .data(scaler ? [scaler.ticks(axisTicks).slice(1)] : [])
      , circle = group.enter()
                      .insert('g', ':first-child')
                        .attr('class', 'rings axis axis-y')
                        .merge(group)
                        .attr('transform', `translate(${dimensions.width / 2}, ${dimensions.height / 2})`)
                        .selectAll('circle.ring')
                        .data(d => d)

    circle.enter()
          .append('circle')
            .attr('class', 'ring')
            .merge(circle)
            .attr('r', scaler)

    circle.exit()
          .remove()

    group.exit().remove()
  })
}

const labels = (selection, dimensions, scaler, formatter, axesConfig) => {
  let group = selection.selectAll('g.ring-labels')
                       .data(scaler ? [scaler.ticks(axisTicks).slice(1)] : [])
    , text = group.enter()
                  .append('g')
                    .attr('class', 'ring-labels axis axis-y')
                    .merge(group)
                    .classed('no-labels', !axesConfig.left.labels)
                    .attr('transform', `translate(${dimensions.width / 2}, ${dimensions.height / 2})`)
                    .selectAll('text.ring-label')
                    .data(d => {
                      return scaler.range()[1] > ringLabelMinRadius ? d : []
                    })

  text.enter()
      .append('text')
        .attr('class', 'ring-label')
        .merge(text)
        .attr('y', d => {
          return -scaler(d)
        })
        .text(formatter)

  text.exit()
      .remove()
  group.exit().remove()
}

/*
 * Polar charts have a few components that we need to draw outside of the
 * individual series.
 */
export const preAnimate = function (chart, selection, series, scalers) {
  let dimensions = {
      width: scalers.x.plotScale.bandwidth(),
      height: chart.datum().dimensions.height
    }
    , formatter = chart.layout.getFormatter('left')

  selection.call(rings, dimensions, scalers.y.left)
           .call(labels, dimensions, scalers.y.left, formatter, chart.datum().axes)
}
